import { DataSeries } from '@next/core-lib/models';
import { createAction, props } from '@ngrx/store';

import {
  GetWeeklyKpiDataRequest,
  ObservationsRegistration,
  Parameter,
  WeeklyKpiDataResult,
} from '../../models/performance.model';

export const setSelectedCycleId = createAction(
  '[Performance] Set selected CycleId',
  props<{ cycleId: number }>(),
);

export const setSelectedWeekNr = createAction(
  '[Performance] Set selected WeekNr',
  props<{ weekNr: number }>(),
);

export const setSelectedSectionIds = createAction(
  '[Performance] Set selected SectionIds',
  props<{ sectionIds: number[] }>(),
);

export const setSelectedKpiParameters = createAction(
  '[Performance] Set selected KPI Parameters',
  props<{ kpiParameters: Parameter[] }>(),
);

export const loadObservationsForCycleRequest = createAction(
  '[Performance] Load observations for cycle request',
  props<{ cycleId: number }>(),
);

export const loadObservationsForCycleSuccess = createAction(
  '[Performance] Load observations for cycle success',
  props<{ observations: ObservationsRegistration[] }>(),
);

export const loadObservationsForCycleFailed = createAction(
  '[Performance] Load observations for cycle failed',
  props<{ error: Error }>(),
);

export const upsertbservationsForCycleRequest = createAction(
  '[Performance] Upsert observations for cycle request',
  props<{ observations: ObservationsRegistration[] }>(),
);

export const upsertObservationsForCycleSuccess = createAction(
  '[Performance] Upsert observations for cycle success',
  props<{ observations: ObservationsRegistration[] }>(),
);

export const upsertObservationsForCycleFailed = createAction(
  '[Performance] Upsert observations for cycle failed',
  props<{ error: Error }>(),
);

export const loadWeeklyKpiResultsRequest = createAction(
  '[Performance] Load weekly KPI Results request',
  props<{ cycleId: number; weeklyKpiDataRequest: GetWeeklyKpiDataRequest }>(),
);

export const loadWeeklyKpiResultsSuccess = createAction(
  '[Performance] Load weekly KPI Results success',
  props<{ results: WeeklyKpiDataResult[] }>(),
);

export const loadWeeklyKpiResultsFailed = createAction(
  '[Performance] Load weekly KPI Results failed',
  props<{ error: Error }>(),
);

export const loadDailyKpiTimeSeriesRequest = createAction(
  '[Performance] Load daily KPI TimeSeries request',
  props<{ cycleId: number; parameter: Parameter; sectionIds: number[] }>(),
);

export const loadTimeSeriesRequest = createAction(
  '[Performance] Load timeseries request',
  props<{ cycleId: number; parameter: Parameter; sectionIds: number[]; rvsIds: number[] }>(),
);

export const loadDailyKpiTimeSeriesSuccess = createAction(
  '[Performance] Load daily KPI TimeSeries success',
  props<{ timeSeries: DataSeries<number, number> }>(),
);

export const loadDailyKpiTimeSeriesFailed = createAction(
  '[Performance] Load daily KPI TimeSeries failed',
  props<{ error: Error }>(),
);
